var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"xs12":"","sm6":"","lg4":"","xl3":""}},[_c('v-card',{staticClass:"ma-3"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('v-card-text',[_c('h2',{staticClass:"display-3 text-xs-center"},[_vm._v(_vm._s(_vm.value))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74416348","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reports/Indicator.vue
// module id = null
// module chunks = 